<template>
  <div class="privacy-policy">
    <v-container class="post-section-parent" color="black">
        <v-layout>
            <v-flex xs1 offset-xs1>
                <a class="text-xs-left" style="color: inherit; text-decoration:none;" href="https://www.imgsurv.com">
                <h1>imgsurv</h1>
                </a>
            </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      defaultActive: 0
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.post-section-parent{
  text-align: center;
}

.post-section-title{
  display: inline-block;
}

.post-section-date{
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue